import { ModalConfirmation, ModalConfirmationProps, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../../../enums/modalId'

interface FecImportSkipFailedFileModalProps extends Pick<ModalConfirmationProps, 'okLoading'> {
  onContinue: () => void | Promise<void>
  onReupload: () => void
}

export const FecImportSkipFailedFileModal = ({
  okLoading,
  onContinue,
  onReupload,
}: FecImportSkipFailedFileModalProps): ReactElement => {
  const { t } = useTranslation()
  const { close } = useModal(ModalId.FecImportSkipFailedFileModal)

  const handleCancel = useCallback(() => {
    onReupload()
  }, [onReupload])

  const handleOk = useCallback(async () => {
    const didContinue = await Promise.resolve()
      .then(onContinue)
      .then(
        () => true,
        () => false,
      )

    if (didContinue) {
      close()
    }
  }, [close, onContinue])

  return (
    <ModalConfirmation
      cancelLabel={t('settings.organization.accounting.fec_file_import.modal.confirmation_step.reupload_button')}
      id={ModalId.FecImportSkipFailedFileModal}
      message={t('settings.organization.accounting.fec_file_import.modal.confirmation_step.skip_failed_file_message')}
      okLabel={t('settings.organization.accounting.fec_file_import.modal.confirmation_step.skip_failed_file_continue')}
      okLoading={okLoading}
      onCancel={handleCancel}
      onOk={handleOk}
      title={t('settings.organization.accounting.fec_file_import.modal.confirmation_step.skip_failed_file_title')}
    />
  )
}
